export const filterImportableQuizzes = (lmsQuizzes, importedQuizzes) => {
    const importedLmsIds = new Set(
        (importedQuizzes || [])
            .map(({ api_assignment_id }) => api_assignment_id)
            .filter((id) => id != null)
            .map(String)
    );

    return (lmsQuizzes || []).filter(({ id }) => !importedLmsIds.has(String(id)));
};
